import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';

export const SqChecklistRadio = (props: {
  name: string;
  value: any;
  handle: any;
  isDisable: any;
  error: boolean;
  checkedInStartDate: any;
}) => {
  return (
    <FormControl error={props.error}>
      <RadioGroup
        row
        aria-labelledby="demo-row-radio-buttons-group-label"
        name={props.name}
        value={props.value}
        onChange={props.handle}
      >
        <FormControlLabel
          disabled={!props.isDisable || !props.checkedInStartDate}
          value="Y"
          control={<Radio />}
          label="Yes"
        />
        <FormControlLabel
          disabled={!props.isDisable || !props.checkedInStartDate}
          value="N"
          control={<Radio />}
          label="No"
        />
        <FormControlLabel
          disabled={!props.isDisable || !props.checkedInStartDate}
          value="NA"
          control={<Radio />}
          label="N/A"
        />
      </RadioGroup>
    </FormControl>
  );
};
